import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MarkdownModule } from './markdown/markdown.module';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';

@NgModule({
  declarations: [
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  imports: [
    CommonModule,
    BrowserModule,
    MarkdownModule
  ],
  providers: []
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {}

  // ngDoBootstrap needs to do nothing when exporting custom elements so that the normal Angular app bootstrap doesn't take place
  ngDoBootstrap() {}
}
